import { SERVER } from 'config/server.config';
import { getFile } from 'helpers';
import { message, notification } from 'antd';
import React from 'react';
const ConflictReportButton =  ({ teamId }:{teamId:string}) => {
  const notificationKey = 'downloadFinished';

const notificationDownload = (name:string) => {
     const args = {
       key: notificationKey,
       message: 'Download In Progress',
       description:
         `Your file ${name} is being processed.`,
       duration: 0,
       icon: <i className='mdi mdi-download' style={{color: '#0378bf'}}></i>
     };
     notification.open(args);
   };
   const notificationDownloadFinish = (name:string) => {
     const args = {
       key: notificationKey,
       message: 'Download Finished',
       description: `Your file ${name} has been downloaded successfully.`,
       duration: 4,
       icon: <i className='mdi mdi-check-underline' style={{color: '#0378bf'}}></i>
     };
     notification.open(args);
  };
    const notificationDownloadError = (name:string) => {
      const args = {
        key: notificationKey,
        message: `Error downloading file ${name}`,
        duration: 4,
        icon: <i className='mdi mdi-alert' style={{color: 'red'}}></i>
      };
      notification.open(args);
    };

const exportConflictReportCSV = async (teamId: string) => {
   const success = await getFile(
    SERVER.ENTITIES_CONFLICT_REPORT_CSV(teamId),
    `${teamId}-Conflict-Report.csv`
  );

  if (success) {
    notificationDownloadFinish(`${teamId}-Conflict-Report.csv`);
  } else {
    notificationDownloadError((`${teamId}-Conflict-Report.csv`));
  }
  };

  return (
    <>
      <a title="Download Conflict CSV" onClick={()=>{
        notificationDownload(`${teamId}-Conflict-Report.csv`);
        exportConflictReportCSV(teamId);}} target="_blank" rel="noreferrer">
        <button className="btn-lo">
          <i className="mdi mdi-download" style={{fontSize: '20px'}}/>
        </button>
      </a>
    </>
  );
};

export default ConflictReportButton;
